import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";

// Sfondo animato leggero ma d'impatto: orbite sfocate che fluttuano e
// si muovono in parallasse durante lo scroll. Funziona in tema chiaro e scuro.
export const AnimatedBackground = () => {
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const y1 = useTransform(scrollYProgress, [0, 1], [0, -160]);
  const y2 = useTransform(scrollYProgress, [0, 1], [0, 180]);
  const y3 = useTransform(scrollYProgress, [0, 1], [0, -90]);

  if (reduce) {
    return <div className="fixed inset-0 -z-10 hero-glow opacity-70 pointer-events-none" aria-hidden="true" />;
  }

  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none" aria-hidden="true">
      <motion.div style={{ y: y1 }} className="absolute -top-32 -left-24">
        <motion.div
          animate={{ x: [0, 40, 0], scale: [1, 1.12, 1] }}
          transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
          className="h-[30rem] w-[30rem] rounded-full bg-sky-500/20 dark:bg-cyan-400/20 blur-3xl"
        />
      </motion.div>

      <motion.div style={{ y: y2 }} className="absolute top-1/3 -right-28">
        <motion.div
          animate={{ x: [0, -50, 0], scale: [1, 1.18, 1] }}
          transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
          className="h-[26rem] w-[26rem] rounded-full bg-blue-500/16 dark:bg-sky-500/20 blur-3xl"
        />
      </motion.div>

      <motion.div style={{ y: y3 }} className="absolute bottom-0 left-1/4">
        <motion.div
          animate={{ x: [0, 30, 0], y: [0, -30, 0], scale: [1, 1.1, 1] }}
          transition={{ duration: 20, repeat: Infinity, ease: "easeInOut" }}
          className="h-[24rem] w-[24rem] rounded-full bg-cyan-400/16 dark:bg-blue-500/20 blur-3xl"
        />
      </motion.div>
    </div>
  );
};
